// src/pages/Accounts/AccountsDashboard.jsx
import React from "react";
import { Card, Row, Col, Typography, Button } from "antd";
import {
  DollarOutlined,
  BankOutlined,
  CreditCardOutlined,
  FileTextOutlined,
  TransactionOutlined,
  SwapOutlined,
  UserOutlined,
  EnvironmentOutlined,
  ContainerOutlined,
  FileSearchOutlined,
  SyncOutlined
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import "./accountsDashboard.css";
import { accessChecker } from "../lib/functions";
import { selectAuthInfo } from "../pages/Auth/authSelectors";
import { useSelector } from "react-redux";

const { Title } = Typography;

const AccountsDashboard = () => {
  const navigate = useNavigate();
  const authInfo = useSelector(selectAuthInfo);
  const shortcuts = [
    {
      key: "account_entry",
      label: "Accounts",
      value: "account_entry",
      path: "/accounts/account-entry",
      icon: <BankOutlined />,
    },
    {
      key: "income_entry",
      label: "Income",
      value: "income_entry",
      path: "/accounts/income",
      icon: <DollarOutlined />,
    },
    {
      key: "expense_entry",
      label: "Expenses",
      value: "expense_entry",
      path: "/accounts/expenses",
      icon: <FileTextOutlined />,
    },
    {
      key: "debtor_receipt",
      label: "Customer/Supplier Receipts",
      value: "debtor_receipt",
      path: "/accounts/debitor-receipts",
      icon: <UserOutlined />,
    },
    {
      key: "creditor_payment",
      label: "Supplier/Customer Payment",
      value: "creditor_payment",
      path: "/accounts/creditor-payments",
      icon: <DollarOutlined />,
    },
    {
      key: "recurring_journal_entry",
      label: "Recurring Journals",
      value: "recurring_journal_entry",
      path: "/accounts/recurring-journals",
      icon: <SyncOutlined />,
    },
    {
      key: "journal_entry",
      label: "Journal / Double",
      value: "journal_entry",
      path: "/accounts/journal-entry",
      icon: <FileSearchOutlined />,
    },
    {
      key: "contra_entry",
      label: "Contra / Single",
      value: "contra_entry",
      path: "/accounts/contra-entry",
      icon: <SwapOutlined />,
    },
    {
      key: "bank_transactions",
      label: "Bank Transactions",
      value: "bank_transactions",
      path: "/accounts/bank-transactions",
      icon: <CreditCardOutlined />,
    },
    {
      key: "cheque_entry",
      label: "Cheques",
      value: "cheque_entry",
      path: "/accounts/cheques",
      icon: <FileTextOutlined />,
    },
    {
      key: "advance_transaction_entry",
      label: "Advance Transactions",
      value: "advance_transaction_entry",
      path: "/accounts/advance-tran",
      icon: <TransactionOutlined />,
    },
    {
      key: "branch_tran",
      label: "Branch Transactions",
      value: "branch_tran",
      path: "/accounts/branch-tran",
      icon: <ContainerOutlined />,
    },
    {
      key: "expense_recognition_entry",
      label: "Expense Recognitions",
      value: "expense_recognition_entry",
      path: "/accounts/expense-recognitions",
      icon: <FileTextOutlined />,
    },
    {
      key: "opening_balances",
      label: "Opening Balances",
      value: "account_entry",
      path: "/accounts/opening-balances",
      icon: <ContainerOutlined />,
    },
  ];

  if (
    authInfo?.branch_company_type === "Pharmacy" ||
    authInfo?.subscription === "SuperERP"
  ) {
    const insuranceReceipt = {
      key: "debitor_pharma_receipts",
      label: "Insurance Receipts",
      value: "debitor_pharma_receipts",
      path: "/accounts/debitor-pharma-receipts",
      icon: <UserOutlined />,
    };
    shortcuts.splice(4, 0, insuranceReceipt);
  }

  // ✅ Filter based on access rights
  const filteredMenuData = shortcuts.filter((menuItem) =>
    accessChecker(menuItem.value)
  );

  return (
    <div style={{ padding: "24px" }}>
      <Title level={3} style={{ marginBottom: 24 }}>
        Accounts Dashboard
      </Title>
      <Row gutter={[16, 16]}>
        {filteredMenuData?.map((item, idx) => (
            <Col xs={24} sm={12} md={8} lg={6} key={idx}>
              <Card
                hoverable
                style={{
                  textAlign: "center",
                  borderRadius: 12,
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                }}
                onClick={() => navigate(item.path)}
              >
                <div style={{ fontSize: 28, marginBottom: 12 }}>
                  {item.icon}
                </div>
                <Button type="link">{item.label}</Button>
              </Card>
            </Col>
          ))}
      </Row>
    </div>
  );
};

export default AccountsDashboard;
